import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface NewBuyerFormGroupItem {
  id: string;
  content: ReactNode;
  label?: string;
  onRemove?: () => void;
}

interface NewBuyerFormGroupProps {
  items: NewBuyerFormGroupItem[];
  maxItems: number;
  addItemLabel: string;
  onAddItem: () => void;
  itemSpacing?: number;
  addButtonSpacing?: number;
}

export const NewBuyerFormGroup = ({
  items,
  maxItems,
  addItemLabel,
  onAddItem,
  itemSpacing = 1.5,
  addButtonSpacing = 0,
}: NewBuyerFormGroupProps) => {
  const showAddButton = items.length < maxItems;
  const isLastItem = (index: number) => index === items.length - 1;

  return (
    <Stack>
      {items.map((item, index) => (
        <Stack
          key={item.id}
          sx={{ gap: 2, pb: isLastItem(index) ? 0 : itemSpacing }}
        >
          {item.label && (
            <Stack
              direction="row"
              sx={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
              <Typography variant="subtitle2">{item.label}</Typography>
              {item.onRemove && (
                <Button
                  variant="link"
                  color="error"
                  onClick={() => {
                    item.onRemove?.();
                  }}
                  size="small"
                >
                  Remove
                </Button>
              )}
            </Stack>
          )}
          {item.content}
        </Stack>
      ))}
      {showAddButton && (
        <Box
          sx={{
            mt: addButtonSpacing,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="link"
            startIcon={<AddIcon fontSize="small" sx={{ marginRight: 0.5 }} />}
            onClick={onAddItem}
          >
            {addItemLabel}
          </Button>
        </Box>
      )}
    </Stack>
  );
};
